function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.806,
    height: 24.035,
    viewBox: "0 0 24.806 24.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 291",
    transform: "translate(-2523.5 -1053.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 799",
    cx: 8.143,
    cy: 8.143,
    r: 8.143,
    transform: "translate(2525 1055)",
    style: {
      strokeWidth: 3,
      fill: "none",
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6",
    transform: "translate(2540.055 1069.5)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 5,
      fill: "none",
      stroke: "#fff"
    },
    d: "m0 0 4.717 4.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.9966c5a9b91e152df3f807ab85757da5.svg";
export { ForwardRef as ReactComponent };